const PattayaFirstLoad = () => {
  // document?.getElementById("scroll_pattaya")?.scrollIntoView({
  //   behavior: "smooth",
  //   block: "start",
  // });
};
export default PattayaFirstLoad;
